import { mapGetters } from 'vuex';

export default {
    watch: {
        getModals: function (e) {
            this.dynamicModalData = this.getModalByKey(this.dynamicModalName);
        }
    },
    computed: {
        ...mapGetters({
            getModalByKey: 'global/getModalByKey',
            getModals: 'global/getModals'
        }),
        dynamicModalData() {
            return this.getModalByKey(this.dynamicModalName);
        },
        isSetDynamicModalData() {
            return this.dynamicModalData ? true : false;
        }
    },
    methods: {
        renderDynamicModalField(fieldName, defaultValue) {
            return this.isSetDynamicModalData && this.dynamicModalData[fieldName]
                ? this.dynamicModalData[fieldName]
                : defaultValue;
        }
    }
};
